"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// This is file should mirror https://github.com/react-navigation/react-navigation/blob/6.x/packages/native/src/ServerContext.tsx
const react_1 = require("react");
const ServerContext = (0, react_1.createContext)(undefined);
exports.default = ServerContext;
//# sourceMappingURL=serverContext.js.map